import React from 'react'
import { cn } from 'src/utils'

const Tag: React.FC<
  React.PropsWithChildren<JSX.IntrinsicElements['button']>
> = ({
  children,
  className,
  ...props
}: React.PropsWithChildren<any>) => (
  <span
    className={cn(
      'relative mx-auto w-fit select-none whitespace-nowrap rounded-full bg-slate-500 px-2 text-center text-[10px]',
      className,
    )}
    {...props}
  >
    {children}
  </span>
)

export default Tag
